var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numbers-card-numbers-card"},[_c('img',{staticClass:"numbers-card-image",attrs:{"alt":_vm.imageAlt,"src":_vm.imageSrc}}),_c('span',{staticClass:"numbers-card-number"},[_vm._v(_vm._s(_vm.number))]),_c('span',{staticClass:"numbers-card-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }